import React from "react";

import { createColumnHelper } from "@tanstack/react-table";

import { CopyTextIcon } from "src/base-components/CopyTextIcon";
import { Cell, Header, TableComp as Table } from "src/base-components/Table";
import { SdkScriptRow } from "src/settings/sdks/types";

const columnHelper = createColumnHelper<SdkScriptRow>();

const columns = [
  columnHelper.accessor("id", {
    header: (info) => <Header info={info}>ID</Header>,
    cell: (info) => (
      <Cell className="!h-auto min-h-[48px] items-center" info={info}>
        <CopyTextIcon
          dataLoc={`copy-script-id-${info.getValue()}`}
          feedback="toast"
          value={info.getValue()}
        />
      </Cell>
    ),
    size: 57,
  }),
  columnHelper.accessor("name", {
    header: (info) => <Header info={info}>Script name</Header>,
    cell: (info) => (
      <Cell className="!h-auto min-h-[48px] items-center" info={info}>
        {info.getValue()}
      </Cell>
    ),
  }),
  columnHelper.accessor("providerLabel", {
    header: (info) => <Header info={info}>Provider</Header>,
    cell: (info) => (
      <Cell className="!h-auto min-h-[48px] items-center" info={info}>
        {info.getValue()}
      </Cell>
    ),
  }),
  columnHelper.accessor("lastUpdatedLabel", {
    header: (info) => <Header info={info}>Last updated</Header>,
    cell: (info) => (
      <Cell className="!h-auto min-h-[48px] items-center" info={info}>
        {info.getValue()}
      </Cell>
    ),
  }),
  columnHelper.accessor("createdAtLabel", {
    header: (info) => <Header info={info}>Created at</Header>,
    cell: (info) => (
      <Cell className="!h-auto min-h-[48px] items-center" info={info}>
        {info.getValue()}
      </Cell>
    ),
  }),
];

type SdkScriptsTableProps = {
  rows: SdkScriptRow[];
  isLoading?: boolean;
  onRowClick?: (row: SdkScriptRow) => void;
};

export const SdkScriptsTable: React.FC<SdkScriptsTableProps> = ({
  rows,
  isLoading = false,
  onRowClick,
}) => (
  <Table
    columns={columns}
    data={rows}
    dataLoc="sdk-scripts-table"
    disableVirtualization
    isLoading={isLoading}
    rowClassName={onRowClick ? "cursor-pointer" : undefined}
    rowPropsGetter={
      onRowClick
        ? (row) => ({ onClick: () => onRowClick(row.original) })
        : undefined
    }
    variant="compact"
  />
);
